export const INSERT_RESOURCE_LIST_TEMPLATE_SECTION_COMMAND =
  'insertResourceListTemplatesSectionCommand';
export const ResourceTemplateSectionSchema = 'resourcesection';

export const ResourceTemplateSectionIdAttr = 'resourcesectionid';
export const ResourceTemplateIdsAttr = 'resourcetemplateids';
export const ResourceTemplateSectionTypeAttr = 'resourcesectiontype';
export const ResourceTemplateSectionFilterTypeAttr =
  'resourcesectionfiltertype';
export const ResourceTemplateSectionFilterWeeksRangeAttr =
  'resourcesectionfilterweeksrange';
export const ResourceTemplateSectionFilterRangeStrAttr =
  'resourcesectionfilterrangestr';
